import KeepAlive from 'react-activation'
import { t } from '@/utils/i18n'

import App from '@/pages/App'
import Navs from '@/pages/App/Navs'
import CategorySearch from '@/pages/App/CategorySearch'
import Login from '@/pages/Login'
import RouterGuard from '@/components/RouterGuard'
import RouterGuardTempLogin from '@/components/RouterGuardTempLogin/RouterGuardTempLogin'
import ShoppingCart from '@/pages/ShoppingCart/Index'
import HttpDemo1 from '@/pages/Demo/HttpDemo1'
import Products from '@/pages/Products/Products'
import ProductDetail from '@/pages/Products/Detail'
import OrderList from '@/pages/Order/Index'
import ConfirmOrder from '@/pages/Order/Confirm'
import Search from '@/pages/Products/Search'
import CorpIntro from '@/pages/Corp/CorpIntro'
import MyCenter from '@/pages/My/Center'
import MyEdit from '@/pages/My/Edit'
import LangSetting from '@/pages/My/LangSetting'
import OrderResult from '@/pages/Order/OrderResult/OrderResult'
import OrderDetail from '@/pages/Order/Detail/Detail'
import ShippingTemplate from '@/pages/Order/ShippingTemplate'
import Marketing from '@/pages/Marketing/Home'
import MarktingSearch from '@/pages/Marketing/Search'
import MarktingNavs from '@/pages/Marketing/Navs'
import Marketing2 from '@/pages/Marketing2/Home'
import Markting2Search from '@/pages/Marketing2/Search'
import Markting2Navs from '@/pages/Marketing2/Navs'
import ProductDetail1688 from '@/pages/Products1688/Detail'
import SvgPreview from '@/pages/SvgPreview/index'
import ReturnDetail from '@/pages/Order/ReturnDetail/ReturnDetail'

import Album from '@/pages/Album/Index'
import AlbumCategory from '@/pages/Album/Category'
import AlbumProductDetail from '@/pages/Album/ProductDetail'

export interface Route {
  path: string
  name: string
  state?: any
  element: JSX.Element
}

export interface RoutesMap {
  [key: string]: string
}

const routes: Route[] = [
  {
    path: '/',
    name: 'App',
    element: (
      <KeepAlive name="Home">
        <RouterGuard>
          <App />
        </RouterGuard>
      </KeepAlive>
    ),
  },
  {
    path: '/category-search',
    name: 'CategorySearch',
    element: (
      <RouterGuard>
        <CategorySearch />
      </RouterGuard>
    ),
  },
  {
    path: '/navs',
    name: 'Navs',
    element: (
      <RouterGuard>
        <Navs />
      </RouterGuard>
    ),
  },
  {
    path: '/login',
    name: 'Login',
    element: <Login />,
  },
  {
    path: '/shopping-cart',
    name: 'ShoppingCart',
    element: (
      <RouterGuard>
        <ShoppingCart />
      </RouterGuard>
    ),
  },
  {
    path: '/confirm-order',
    name: 'ConfirmOrder',
    element: (
      <KeepAlive name="ConfirmOrder">
        <ConfirmOrder />
      </KeepAlive>
    ),
  },
  {
    path: '/order-list',
    name: 'OrderList',
    element: <OrderList />,
  },
  {
    path: '/products',
    name: 'Products',
    state: {
      title: '全部货品',
    },
    element: (
      <KeepAlive name="Products">
        <Products />
      </KeepAlive>
    ),
  },
  {
    path: '/product/detail/:productId',
    name: 'ProductDetail',
    element: <ProductDetail />,
  },
  {
    path: '/products/search',
    name: 'Search',
    element: <Search />,
  },
  {
    path: '/corp/corp-intro',
    name: 'CorpIntro',
    element: <CorpIntro />,
  },
  {
    path: '/my-center',
    name: 'MyCenter',
    element: (
      <RouterGuard>
        <MyCenter />
      </RouterGuard>
    ),
  },
  {
    path: '/my-edit',
    name: 'MyEdit',
    element: <MyEdit />,
  },
  {
    path: '/lang-setting',
    name: 'LangSetting',
    element: <LangSetting />,
  },
  {
    path: '/order-result',
    name: 'OrderResult',
    element: <OrderResult />,
  },
  {
    path: '/order/detail/:orderId',
    name: 'OrderDetail',
    element: <OrderDetail />,
  },
  {
    path: '/order/shipping-template/',
    name: 'ShippingTemplate',
    element: <ShippingTemplate />,
  },
  {
    path: '/marketing',
    name: 'Marketing',
    element: (
      <KeepAlive name="Marketing">
        <RouterGuardTempLogin>
          <Marketing />
        </RouterGuardTempLogin>
      </KeepAlive>
    ),
  },
  {
    path: '/marketing/search',
    name: 'MarktingSearch',
    element: <MarktingSearch />,
  },
  {
    path: '/marketing/navs',
    name: 'MarktingNavs',
    element: <MarktingNavs />,
  },
  {
    path: '/marketing2',
    name: 'Marketing2',
    element: (
      <KeepAlive name="Marketing2">
        <RouterGuardTempLogin>
          <Marketing2 />
        </RouterGuardTempLogin>
      </KeepAlive>
    ),
  },
  {
    path: '/marketing2/search',
    name: 'Markting2Search',
    element: <Markting2Search />,
  },
  {
    path: '/marketing2/navs',
    name: 'Markting2Navs',
    element: <Markting2Navs />,
  },
  {
    path: '/product-1688/detail/:offerId',
    name: 'ProductDetail1688',
    element: <ProductDetail1688 />,
  },
  {
    path: '/http-demo1',
    name: 'HttpDemo1',
    element: <HttpDemo1 />,
  },
  {
    path: '/svg-preview',
    name: 'SvgPreview',
    element: <SvgPreview />,
  },
  {
    path: '/order/return-detail/:orderId',
    name: 'ReturnDetail',
    element: <ReturnDetail />,
    state: {
      title: '退货单详情',
    },
  },

  // 相册模块
  {
    path: '/album/:corpId',
    name: 'Album',
    state: {
      getTitle: () => t('新品2'),
    },
    element: (
      <RouterGuardTempLogin>
        <Album />
      </RouterGuardTempLogin>
    ),
  },
  {
    path: '/album/:corpId/category',
    name: 'AlbumCategory',
    state: {
      getTitle: () => t('商品分类'),
    },
    element: (
      <RouterGuardTempLogin>
        <AlbumCategory />
      </RouterGuardTempLogin>
    ),
  },
  {
    path: '/album/product-detail/:corpId/:productId',
    name: 'AlbumProductDetail',
    state: {
      getTitle: () => t('货品详情'),
    },
    element: (
      <RouterGuardTempLogin>
        <AlbumProductDetail />
      </RouterGuardTempLogin>
    ),
  },
]

// 用来做路由导航时路径名和路径的映射
export const routesMap: RoutesMap = routes.reduce(
  (acc: RoutesMap, cur: Route) => {
    const { path, name } = cur
    acc[name] = path
    return acc
  },
  {},
)

export default routes
